module.exports = __webpack_public_path__ + "img/walletlink.f40549fa.svg";